module.exports = __webpack_public_path__ + "img/pic_subject_other.ff4a904c.png";